module.exports = __webpack_public_path__ + "static/media/noto.0f0ea204.ttf";